export default class CaseTransformer {
  static toSnake(string) {
    return string
      .split('')
      .map((letter, index) => {
        if (/[A-Z]/.test(letter)) {
          return `_${letter.toLowerCase()}`
        }
        return letter
      })
      .join('');
  }

  static keysToSnake(object) {
    const entries = Object.entries(object);
    entries.forEach((entry, idx) => {
      entries[idx][0] = CaseTransformer.toSnake(entries[idx][0])
    });
    return Object.fromEntries(entries);
  }
}
